import React, { useEffect, useState } from 'react';
import { getVisitsTrackingTimeLineAPI } from '../../api/protocol.js';
import { HandleApiError } from '../../components/Notifications/APIErrorHandler.js';
import { FormHeader } from '../../components/Protocols/Tracking/Forms.jsx';

const VisitHeaderContainer = ({ protocolId, patientId }) => {

    const [visits, setVisits] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let isSubscribed = true;

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const resp = await getVisitsTrackingTimeLineAPI(protocolId, patientId);
                if (isSubscribed) {
                    setVisits(resp.data);
                    setIsLoading(false);
                }
            }
            catch (error) {
                if (isSubscribed) {
                    console.log(error);
                    HandleApiError(error);
                    setIsLoading(false);
                }
            }
        }

        fetchData();
    }, [protocolId]);

    if (isLoading || !visits)
        return null;

    return (
        <FormHeader protocolId={protocolId} patientId={patientId} visits={visits} />
    );
}

export default VisitHeaderContainer;